module.exports = __webpack_public_path__ + "static/media/avatar-default.f93a166e.jpeg";